import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4570e88f&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=4570e88f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4570e88f",
  null
  
)

export default component.exports